import {
  SlSwitch
} from "./chunk.3R6PU6LJ.js";

// src/components/switch/switch.ts
var switch_default = SlSwitch;
SlSwitch.define("sl-switch");

export {
  switch_default
};
